import { Search } from "@mui/icons-material";
import {
  Box,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { tags } from "../../assets/dummyData";
import { motion, AnimatePresence } from "framer-motion";
import { colors } from "../../theme/theme";

const HomePageSearchBar = ({ search, setSearch }) => {
  const navigate = useNavigate();

  const [index, setIndex] = useState(0);
  const [typedText, setTypedText] = useState("");
  const [showText, setShowText] = useState(true);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  useEffect(() => {
    const currentTag = tags[index].name;
    setTypedText("");
    setShowText(true);

    let charIndex = 0;
    const typingInterval = setInterval(() => {
      setTypedText(currentTag.slice(0, charIndex + 1));
      charIndex++;
      if (charIndex === currentTag.length) {
        clearInterval(typingInterval);
        setTimeout(() => setShowText(false), 1000);
      }
    }, 100);

    return () => clearInterval(typingInterval);
  }, [index]);

  useEffect(() => {
    if (!showText) {
      const timeout = setTimeout(() => {
        setIndex((prev) => (prev + 1) % tags.length);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [showText]);

  const handleSearch = () => {
    if (search.trim().length > 0) {
      navigate(`/search?q=${encodeURIComponent(search)}`);
    }
  };

  return (
    <Box
      sx={{
        mx: 2,
        mb: 2,
        borderTopLeftRadius: "28px",
        borderTopRightRadius: "0px",
        borderBottomLeftRadius: "28px",
        borderBottomRightRadius: "28px",
        py: 1,
        px: 2,
        backgroundColor: colors.pinkColor,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Poppins-SemiBold",
          fontSize: isMobile ? "24px" : "32px",
          color: colors.textColor,
          maxWidth: isMobile ? "90%" : "80%",
          lineHeight: isMobile ? "28px" : "34px",
          mb: 2,
          mt: 1,
        }}
      >
        What Are You shopping for?
      </Typography>
      <Box sx={{ position: "relative", width: "100%" }}>
        <TextField
          variant="outlined"
          placeholder=""
          value={search}
          autoComplete="off"
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          sx={{
            mb: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "27px",
              height: "40px",
              backgroundColor: "#fff",
              "& input": { paddingLeft: "16px" },
              "& fieldset": { borderColor: "#FFB79C" },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#FFB79C !important",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#FFB79C",
              },
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                onClick={handleSearch}
                style={{ cursor: "pointer" }}
              >
                <Search sx={{ color: "#e1e1e1" }} />
              </InputAdornment>
            ),
          }}
          fullWidth
        />

        {!search && (
          <Box
            sx={{
              position: "absolute",
              left: "16px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#9e9e9e",
              pointerEvents: "none",
              overflow: "hidden",
              height: "1.9em",
            }}
          >
            <AnimatePresence mode="wait">
              {showText && (
                <motion.span
                  key={index}
                  initial={{ y: "100%", opacity: 0 }}
                  animate={{ y: "0%", opacity: 1 }}
                  exit={{ y: "-100%", opacity: 0 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  style={{
                    display: "block",
                    whiteSpace: "nowrap",
                    fontSize: "0.9rem",
                  }}
                >
                  {typedText}
                  <motion.span
                    animate={{ opacity: [0, 1, 0] }}
                    transition={{ repeat: Infinity, duration: 1 }}
                    style={{ display: "inline-block" }}
                  >
                    |
                  </motion.span>
                </motion.span>
              )}
            </AnimatePresence>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default HomePageSearchBar;
